<div class="bg-[#FAFAFA] rounded-[20px] p-2 sm:p-0 space-y-6">

  <!-- PAGE HEADER -->
  <div class="flex items-center justify-between">
    <h1 class="text-xl sm:text-xl font-semibold text-[#444A6D]">
    </h1>
    <button class="bg-indigo-600 text-white text-sm px-4 py-2 rounded-lg" (click)="showPopup = true">
      {{ 'SETUP.KIBOR.ADD_BUTTON' | translate }}
    </button>
  </div>

  <!-- =========================
               SECTION 1: CURRENT KIBOR
          ========================== -->
  <div class="bg-white rounded-[18px] p-6 ">

    <h2 class="text-sm font-semibold text-[#151D48] mb-4">
      {{ 'SETUP.KIBOR.CURRENT_RATE' | translate }}
    </h2>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-7 max-w-3xl">
      <div>
        <label class="form-label">{{ 'SETUP.KIBOR.RATE' | translate }}</label>
        <input type="text" [value]="currentKiborRate" readonly class="form-input bg-gray-100 cursor-not-allowed" />
      </div>

      <div>
        <label class="form-label">{{ 'SETUP.KIBOR.EFFECTIVE_START_DATE' | translate }}</label>
        <input type="text" [value]="currentStartDate" readonly class="form-input bg-gray-100 cursor-not-allowed" />
      </div>

      <div>
        <label class="form-label">{{ 'SETUP.KIBOR.EFFECTIVE_END_DATE' | translate }}</label>
        <input type="text" [value]="currentEndDate" readonly class="form-input bg-gray-100 cursor-not-allowed" />
      </div>
    </div>

  </div>

  <!-- =========================
               SECTION 2: TABLE
          ========================== -->
  <div class=" ">

    <!-- TABLE HEADER -->
    <div class="flex items-center justify-between px-6 py-2  bg-white rounded-[6px]">
      <h2 class="text-lg font-semibold ">
        {{ 'SETUP.KIBOR.HISTORY' | translate }}
      </h2>


    </div>

    <!-- TABLE -->
    <div class="">
      <app-table [columns]="columns" [data]="data">
      </app-table>
    </div>

  </div>

</div>
<app-popup [title]="'SETUP.KIBOR.ADD_RATE'" [fields]="popupFields" [onSave]="handleSave.bind(this)" [show]="showPopup"
  (showChange)="showPopup = $event">
</app-popup>